module.exports = __webpack_public_path__ + "img/stock-photo-2.689f109f.jpg";